import type { IconProps } from '../_.type';
import type { CreateGoogleIconFontVariationOptions, GoogleIconFontVariation, GoogleIconsMap } from './_google.type';

const STYLES: Record<NonNullable<IconProps['size']>, [weight: number, opticalSize: number]> = {
  xxs: [350, 32],
  xs: [350, 32],
  sm: [350, 32],
  md: [250, 32],
  lg: [300, 32],
  xl: [300, 32],
};

const fontVariation = ({ fill, weight, grade, opticalSize }: GoogleIconFontVariation) =>
  `'FILL' ${fill}, 'wght' ${weight}, 'GRAD' ${grade}, 'opsz' ${opticalSize}`;

/**
 * Create default GoogleIcon FontVariation.
 *
 * @param {CreateGoogleIconFontVariationOptions} options Options.
 *
 * @returns {string} Default GoogleIcon FontVariation.
 */
export function defaultGoogleIconFontVariation({ fill, size = 'md' }: CreateGoogleIconFontVariationOptions): string {
  const [weight, opticalSize] = STYLES[size];

  return fontVariation({
    fill: fill ? 1 : 0,
    weight,
    grade: 0,
    opticalSize,
  });
}

/** Map google icon. */
const googleIconsMap: GoogleIconsMap = {};

export default googleIconsMap;
